import React, { useEffect, PropsWithChildren, MouseEvent } from "react";
import { default as Button } from "./Button";
import { clsx } from "clsx";

type Props = {
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  onDismiss?: () => void;
  type?: string;
  centered?: boolean;
  noIcon?: boolean;
  className?: string;
  closeLabel?: string;
  dismissable?: boolean;
  escClose?: boolean;
};

const Alert = ({
  type,
  children,
  centered,
  noIcon,
  dismissable,
  onDismiss,
  closeLabel,
  className,
  escClose,
}: PropsWithChildren<Props>) => {
  useEffect(() => {
    const handleKeypress = (event: KeyboardEvent) => {
      // dismiss upon pressing the escape key
      if (escClose && event.keyCode === 27 && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    };

    if (escClose) {
      window.addEventListener("keydown", handleKeypress);
      return () => window.removeEventListener("keydown", handleKeypress);
    }
  }, []);

  return (
    <div
      className={clsx({
        alert: true,
        [`${type ? "alert-" + type : ""}`]: type,
        ta_center: centered,
        "no-icon": noIcon,
        "alert-dismissable": dismissable,
        [`${className ? className : ""}`]: className,
      })}
    >
      {children}

      {onDismiss && <Button className="close" onClick={onDismiss} label={closeLabel} />}
    </div>
  );
};

export default Alert;
